import emailValidator from 'email-validator';
import isUrl from 'is-url';

export const isEmailValid = value => {
  if (!value) {
    return false;
  }
  return emailValidator.validate(value);
};

export const isPasswordValid = value => {
  return value != null && value !== '';
};

export const isUrlValid = value => {
  if (!value) {
    return false;
  }
  return isUrl(value);
};

export const isNumeric = value => {
  return /^-?\d+$/.test(value);
};

export default {
  isEmailValid,
  isPasswordValid,
  isUrlValid,
  isNumeric,
};
